<template lang="">
    <Particles
      id="tsparticles"
      :particlesInit="particlesInit"
      :particlesLoaded="particlesLoaded"
      :options="options"
    />
</template>
<script>
import { loadFull } from "tsparticles";
export default {
  name:'CustomColored',
  data() {
    return {
      options: {
  fpsLimit: 60,
  interactivity: {
    detectsOn: "canvas",
    events: {
      resize: true
    }
  },
  particles: {
    color: {
      value: [
        "#3998D0",
        "#2EB6AF",
        "#A9BD33",
        "#FEC73B",
        "#F89930",
        "#F45623",
        "#D62E32",
        "#EB586E",
        "#9952CF"
      ]
    },
    move: {
      attract: {
        enable: false,
        rotate: {
          x: 800,
          y: 800
        }
      },
      direction: "none",
      enable: true,
      outModes: {
        default: "destroy"
      },
      random: false,
      speed: 3,
      straight: false,
      trail: {
        fillColor: "#ffffff",
        length: 30,
        enable: true
      }
    },
    number: { density: { enable: true, area: 800 }, value: 0 },
    opacity: {
      value: 1
    },
    shape: {
      type: "circle"
    },
    size: {
      value: 25,
      animation: {
        startValue: "min",
        enable: true,
        minimumValue: 1,
        speed: 2,
        destroy: "max",
        sync: true
      }
    }
  },
  detectRetina: true,
        emitters: {
    life: {
      count: 50,
      duration: 0.1,
      delay: 0.1
    },
    direction: "none",
    rate: {
      quantity: 5,
      delay: 0.3
    },
    size: {
      width: 0,
      height: 0
    },
    position: {
      x: 50,
      y: 50
    }
  }
}
    }
  },
  methods: {
    async particlesInit (engine) {
    await loadFull(engine)
    },
    async particlesLoaded(container){

      setTimeout(function () {
 	      container.destroy();
      }, 20000)
  }
  },
}
</script>
<style lang="scss">

</style>
